import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";

const StatCard = ({ title, value, color }) => {
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Paper
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FFF",
          borderLeft: `5px solid ${color}`,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          height: "100px",
          width: "100%", // Makes the card occupy full width of grid
          textAlign: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ color: "#666", fontWeight: "bold" }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            mt: 1,
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          {value}
        </Box>
      </Paper>
    </Grid>
  );
};

export default StatCard;
